import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-[#055862] to-[#ff7a00] text-white pt-16 pb-10">
      <div className="container mx-auto px-4 grid md:grid-cols-4 gap-10">

        {/* Logo + Description */}
        <div>
          <img src="/logo.png" alt="iDisKover Logo" className="h-20 mb-4" />
          <p className="text-sm leading-relaxed text-white/90">
            Discover a next-gen digital library platform for accessing, managing, and enriching scholarly content with AI-powered intelligence.
          </p>
          <div className="flex gap-4 mt-6">
            <a
              href="https://facebook.com"
              title="Follow us on Facebook"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              title="Follow us on Twitter"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://linkedin.com"
              title="Connect on LinkedIn"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://instagram.com"
              title="Follow us on Instagram"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4 underline underline-offset-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login">Login</Link></li>
            <li><Link to="/features">Key Features</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/terms">Terms and Conditions</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="text-lg font-semibold mb-4 underline underline-offset-4">Subscribe Newsletter</h4>
          <p className="text-sm mb-4">Stay updated with the latest from iDisKover.</p>
          <form className="flex">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-3 py-2 rounded-l bg-white text-black focus:outline-none"
            />
            <button type="submit" className="bg-white text-[#055862] px-4 py-2 rounded-r hover:bg-orange-500 hover:text-white transition">
              Subscribe
            </button>
          </form>
        </div>

        {/* Gallery Thumbs */}
        <div>
          <h4 className="text-lg font-semibold mb-4 underline underline-offset-4">Powered by</h4>
          <div className="flex flex-col items-start gap-4">
            {[1, 2].map((i) => (
              <img
                key={i}
                src={`/gallery/thumb${i}.png`} // Replace with your image URLs
                alt={`Gallery ${i}`}
                className="h-14 object-contain hover:scale-105 transition-transform duration-200"
              />
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-12 border-t border-white/20 pt-6 text-sm flex flex-col sm:flex-row justify-between items-center px-4">
        <p className="text-white/80">&copy; {new Date().getFullYear()} iDisKover. All rights reserved.</p>
        <div className="flex gap-4 mt-4 sm:mt-0">
          <Link to="/privacy" className="hover:underline">Privacy & Policy</Link>
          <span className="opacity-60">||</span>
          <Link to="/terms" className="hover:underline">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
}
